import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/xddp/appEnv';

export default appStarterFactory(appEnv);
